<template>
  <div id="example_wrapper" class="dataTables_wrapper dt-bootstrap4">
    <div class="table-responsive">
      <table
        style="width: 100%"
        :id="id"
        class="display table table-striped table-bordered"
      >
        <thead>
          <tr role="row">
            <th
              v-for="(head, index1) in tableHeader"
              :key="index1"
              :style="`width: ${width[index1]}%`"
            >
              {{ head }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(row, rowIndex) in tableRows" :key="rowIndex" role="row">
            <td
              v-for="(col, colIndex) in row"
              :key="colIndex"
              v-html="row[colIndex]"
            ></td>
          </tr>
        </tbody>

        <!-- Table Footer (conditionally rendered) -->
        <tfoot style="font-weight: bold;">
          <tr role="row">
            <td v-for="(footer, index) in tableFooter" :key="index">
              {{ footer }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableComponent",
  props: {
    tableRows: Array,
    specialRows: Array,
    tableHeader: Array,
    tableSearch: { default: true },
    tableFooter: { type: Array, default: () => [] },
    width: Array,
    id: String,
  },
  created() {
    // this.$props.specialRows.forEach((specialRow, index)=>{
    //   this.addNewColumn(this.$props.tableRows, specialRow.column, specialRow.content);
    // })
  },
  methods: {
    // addNewColumn(rows, column, content) {
    //   rows.forEach((item,index) => {
    //     item.button = content
    //   });
    // }
  },
};
</script>
